import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "m-iconNotice__block" }
const _hoisted_2 = { class: "m-iconNotice__textblock" }
const _hoisted_3 = {
  key: 0,
  class: "m-iconNotice__switch"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_Switch = _resolveComponent("Switch")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["m-iconNotice", {
        '-is-interactive': _ctx.state.hasSwitch,
        '-active': _ctx.state.switchState?.state,
        '-error': _ctx.state.type === _ctx.IconNoticeType.Error,
        '-success': _ctx.state.type === _ctx.IconNoticeType.Success,
        '-warning': _ctx.state.type === _ctx.IconNoticeType.Warning,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_IconComponent, {
        class: "m-iconNotice__icon",
        iconId: _ctx.state.icon
      }, null, 8, ["iconId"]),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    (_ctx.state.hasSwitch)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_Switch, {
            state: _ctx.state.switchState,
            onStateChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleChangeOf($event)))
          }, null, 8, ["state"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}